import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, Layers, Activity, BookOpen } from "lucide-react";
import { prefetchProps } from "@/lib/prefetch";

/* Mobile-only bottom quick-nav · trimmed to 4 destinations (was 5) so
   each tap target gets ~25% of the viewport width. The "Open Account"
   path lives in the floating sticky CTA, not in this nav. */
const ITEMS = [
  { to: "/",                    Icon: Home,     key: "home",     fallback: "Home" },
  { to: "/account-comparison",  Icon: Layers,   key: "accounts", fallback: "Accounts" },
  { to: "/live-spreads",        Icon: Activity, key: "markets",  fallback: "Markets" },
  { to: "/faq",                 Icon: BookOpen, key: "help",     fallback: "Help" },
];

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  return (
    <nav
      data-testid="mobile-bottom-nav"
      aria-label={t("nav.bottomQuickNav", "Quick navigation")}
      className="lg:hidden fixed inset-x-0 bottom-0 z-40 border-t"
      style={{
        background: "color-mix(in srgb, var(--bg) 88%, transparent)",
        backdropFilter: "blur(14px)",
        borderColor: "var(--line-strong)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <div className="grid grid-cols-4">
        {ITEMS.map(({ to, Icon, key, fallback }) => {
          const active = pathname === to;
          // Reuse the existing `nav.<key>` keys we just added in 7 locales.
          const label = t(`nav.${key === "markets" ? "trading" : key}`, fallback);
          return (
            <Link
              key={to}
              to={to}
              data-testid={`mbn-${key}`}
              {...prefetchProps(to)}
              className="flex flex-col items-center justify-center gap-1 py-2.5 text-[12px] font-medium tracking-wide"
              style={{
                color: active ? "var(--brand)" : "var(--text-3)",
                background: active ? "color-mix(in srgb, var(--brand) 6%, transparent)" : "transparent",
              }}
            >
              <Icon size={17} strokeWidth={active ? 2.2 : 1.7} />
              {label}
              {active && (
                <span
                  className="absolute bottom-0 w-7 h-0.5 rounded-t-full"
                  style={{ background: "var(--brand)", boxShadow: "0 0 10px color-mix(in srgb, var(--brand) 70%, transparent)" }}
                  aria-hidden
                />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
